import { render, staticRenderFns } from "./s_ManageClients.vue?vue&type=template&id=6670d62d&scoped=true&"
import script from "./s_ManageClients.vue?vue&type=script&lang=js&"
export * from "./s_ManageClients.vue?vue&type=script&lang=js&"
import style0 from "./s_ManageClients.vue?vue&type=style&index=0&id=6670d62d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670d62d",
  null
  
)

export default component.exports